import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["context", "fundsDescription", "button", "feedback"]
  static values = { url: String }

  connect() {
    this.draft = null
    this.busy = false
    this.toggle()
  }

  // EOS IA met en forme l'intention du conseiller, il ne l'invente pas : tant que le champ est
  // vide, il n'y a rien à améliorer.
  toggle() {
    if (this.busy || this.draft !== null) return

    this.buttonTarget.disabled = this.contextTarget.value.trim().length === 0
  }

  // Le brouillon du conseiller ne doit jamais être perdu : tant qu'il n'a pas enregistré, il peut
  // revenir à son texte d'un clic.
  improve() {
    if (this.busy) return
    if (this.draft !== null) return this.revert()

    const draft = {
      context: this.contextTarget.value,
      fundsDescription: this.fundsDescription
    }
    this.busy = true
    this.buttonTarget.disabled = true
    this.buttonTarget.textContent = "Amélioration en cours…"
    this.feedbackTarget.textContent = ""

    fetch(this.urlValue, {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "X-CSRF-Token": document.querySelector("meta[name=csrf-token]").content
      },
      body: JSON.stringify({ context: draft.context })
    })
      .then((response) => response.json().then((data) => {
        if (!response.ok) throw new Error(data.error || "Impossible de contacter EOS IA.")

        return data
      }))
      .then((data) => {
        this.draft = draft
        this.contextTarget.value = data.context
        this.fundsDescription = data.funds_description
        this.buttonTarget.textContent = "Revenir à mon brouillon"
        this.feedbackTarget.textContent = "Relisez les deux textes avant d'enregistrer : ils seront repris dans le rapport et le courriel adressés au client."
      })
      .catch((error) => {
        this.buttonTarget.textContent = "Améliorer avec EOS IA"
        this.feedbackTarget.textContent = error.message
      })
      .finally(() => {
        this.busy = false
        this.buttonTarget.disabled = false
        this.toggle()
      })
  }

  // La description des fonds est un fragment HTML édité dans Summernote : l'éditeur masque le
  // textarea, il faut donc passer par son API plutôt que par la valeur du champ.
  get fundsDescription() {
    if (this.hasSummernote) {
      return window.jQuery(this.fundsDescriptionTarget).summernote("code")
    }

    return this.fundsDescriptionTarget.value
  }

  set fundsDescription(html) {
    if (this.hasSummernote) {
      window.jQuery(this.fundsDescriptionTarget).summernote("code", html)
    } else {
      this.fundsDescriptionTarget.value = html
    }
  }

  get hasSummernote() {
    return Boolean(window.jQuery && window.jQuery(this.fundsDescriptionTarget).data("summernote"))
  }

  revert() {
    this.contextTarget.value = this.draft.context
    this.fundsDescription = this.draft.fundsDescription
    this.draft = null
    this.buttonTarget.textContent = "Améliorer avec EOS IA"
    this.feedbackTarget.textContent = ""
    this.toggle()
  }
}
